// Pays des destinataires : liste de référence et normalisation (décision du 07/10/2026, après
// l'incident EFFIA : 99 destinataires importés avec « FR », vus comme étrangers).
// Même algorithme dans functions/countries.js et api/src/domain/countries.js : les garder identiques.
// Liste : countries.json, généré par scripts/generate-countries.js.
import data from "./countries.json";

// Pays traités en national : plages de numéros AR et liasse. Outre-mer inchangé (décision du
// 07/10/2026) : un territoire écrit en toutes lettres reste en saisie manuelle.
export const NATIONAL_CODES = ["FR"];

// Clé de comparaison : sans accents, minuscules, sans ponctuation ni espaces (« Royaume-Uni »,
// « royaume uni » et « ROYAUME UNI » donnent la même clé)
export function countryKey(value) {
  return String(value)
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
}

const byCode = {};
const index = {};
const ambiguous = new Set();
data.countries.forEach((country) => {
  byCode[country.code] = country;
});
// Priorité : codes ISO, puis noms officiels, puis alias. Un alias porté par deux pays (« Congo »)
// est ambigu : il est retiré, la saisie doit être précise.
[
  (c) => [c.code, c.alpha3],
  (c) => [c.name],
  (c) => c.aliases,
].forEach((valuesOf, pass) => {
  data.countries.forEach((country) => {
    valuesOf(country).forEach((value) => {
      const key = countryKey(value);
      if (!key || ambiguous.has(key)) return;
      if (!(key in index)) index[key] = { code: country.code, pass };
      else if (index[key].code !== country.code && index[key].pass === pass) {
        delete index[key];
        ambiguous.add(key);
      }
    });
  });
});

export const FRANCE = { code: "FR", name: byCode.FR.name };

// { code, name } avec le nom canonique en français ; vide → France ; inconnu → null
export function normalizeCountry(value) {
  if (value === undefined || value === null || String(value).trim() === "") return FRANCE;
  const entry = index[countryKey(value)];
  return entry ? { code: entry.code, name: byCode[entry.code].name } : null;
}

// Pays d'un destinataire enregistré : country_code s'il existe, sinon déduit de country
// (anciennes données, ex. « FR »)
export function recipientCountry(recipient) {
  const code = recipient && recipient.country_code;
  if (code && byCode[code]) return { code, name: byCode[code].name };
  return normalizeCountry(recipient && recipient.country);
}

// International : pays reconnu hors NATIONAL_CODES, ou pays non reconnu (anciennes données
// seulement : la saisie n'accepte plus que la liste)
export function isInternationalRecipient(recipient) {
  const country = recipientCountry(recipient);
  return !country || !NATIONAL_CODES.includes(country.code);
}

// Options du sélecteur : France en tête, puis ordre alphabétique ; `search` = toutes les clés
// acceptées (noms, alias, codes)
export const COUNTRY_OPTIONS = [
  byCode.FR,
  ...data.countries.filter((country) => country.code !== "FR"),
].map((country) => ({
  value: country.name,
  label: country.name,
  code: country.code,
  search: [country.code, country.alpha3, country.name, ...country.aliases].map(countryKey).join(" "),
}));
